import React from 'react';
import './RankingLeftPanel.css';

function RankingLeftPanel({
  collapsed = false,
  onToggleCollapse,
  title = '필터',
  clearVisible = false,
  onClear,
  clearText = '초기화',
  collapseText = '«',
  expandText = '»',
  collapsedLabel = '',
  className = '',
  topContent = null,
  children = null,
}) {
  if (collapsed) {
    const label = collapsedLabel || title;
    return (
      <aside className={`complex-region-sidebar collapsed ${className}`.trim()}>
        <button
          type="button"
          className="complex-region-sidebar-expand"
          onClick={onToggleCollapse}
          title="펼치기"
          aria-label="펼치기"
        >
          {expandText}
        </button>
        <div className="complex-region-sidebar-collapsed-label" aria-hidden="true">
          {Array.from(label).map((ch, i) => (
            <span key={i}>{ch}</span>
          ))}
        </div>
      </aside>
    );
  }

  return (
    <aside className={`complex-region-sidebar ${className}`.trim()}>
      <button
        type="button"
        className="complex-region-sidebar-hide-top"
        onClick={onToggleCollapse}
        title="숨기기"
        aria-label="숨기기"
      >
        {collapseText}
      </button>
      {topContent}
      <div className="complex-region-sidebar-head">
        <strong>{title}</strong>
        <div className="complex-region-sidebar-actions">
          {clearVisible && typeof onClear === 'function' && (
            <button
              type="button"
              className="complex-region-sidebar-clear"
              onClick={onClear}
              title={clearText}
              aria-label={clearText}
            >
              {clearText}
            </button>
          )}
        </div>
      </div>
      {children}
    </aside>
  );
}

export default RankingLeftPanel;

